import {REPORTS} from './reportsActionsTypes';

export function getReportsPhoto(id) {
  return {
    type: REPORTS.GET_PHOTO_REPORTS,
    payload: {
      client: 'default',
      request: {
        url: `projects/${id}/reports/images`,
        method: 'get'
      }
    }
  };
}

export function getReportsVideo(id) {
  return {
    type: REPORTS.GET_VIDEO_REPORTS,
    payload: {
      client: 'default',
      request: {
        url: `projects/${id}/reports/video`,
        method: 'get'
      }
    }
  };
}

export function uploadReport(id, data) {
  return {
    type: REPORTS.UPLOAD_REPORT,
    payload: {
      request: {
        url: `projects/${id}/reports`,
        method: 'post',
        data
      }
    }
  };
}

export function deleteReport(id, data) {
  return {
    type: REPORTS.DELETE_REPORT,
    payload: {
      request: {
        url: `projects/${id}/reports`,
        method: 'delete',
        data
      }
    }
  };
}
export function downloadReport(docId) {
  return {
    type: REPORTS.DELETE_REPORT,
    payload: {
      request: {
        url: `/projects/reports/download`,
        method: 'post',
        responseType: 'blob',
        data: {ids: docId}
      }
    }
  };
}
export function clearReports() {
  return {
    type: REPORTS.CLEAR_REPORTS,
    payload: {}
  };
}

export function setTime() {
  return {
    type: REPORTS.REPORTS_UPDATE_TIME,
    payload: {}
  };
}
